import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { CreateTemplateData } from "types/Template";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

type CreateTemplateProps = {
  data: CreateTemplateData;
}

async function createTemplate(data: CreateTemplateData) {
  const { data: response } = await api.post('/templates', { ...data })
    .then(axiosSuccess)
    .catch(axiosError);
  return response;
}

export function useCreateTemplate() {
  const queryClient = useQueryClient();

  return useMutation(({ data }: CreateTemplateProps) => createTemplate(data), {
    onSuccess: (data: any) => {
      handleRequestSuccess(`Template "${data.title}" criado com sucesso!`);
      queryClient.invalidateQueries('admin-templates');
      queryClient.invalidateQueries('templates');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Ocorreu um erro ao criar o template. Por favor, tente novamente!');
    }
  });
}
